// import React, { useState, useEffect, useRef } from 'react';
// import './Header.css';
// import { FaCogs, FaGlobe, FaHome, FaUserEdit, FaWifi, FaExternalLinkSquareAlt, FaEnvelope, FaPhoneSquareAlt, FaUser, FaServer, FaSearch, FaCloud, FaLightbulb } from "react-icons/fa";
// import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
// import { Link, NavLink, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { resetUser, selectUserExists, setUserData } from "../redux/userSlice";
// import { setFacultyProfileData } from '../redux/facultySlice';
// import { setStaffData } from '../redux/staffSlice';
// import { toast } from 'react-toastify';
// import { Base_Url } from '../config.js';
// import Logo from "../Assests/logo.png"
// import { MdManageAccounts } from "react-icons/md";
// import { FiLogOut } from 'react-icons/fi';
// import { TbCloudComputing, TbRouteSquare2 } from "react-icons/tb";
// import { FaExternalLinkAlt } from "react-icons/fa";
// import { LiaFileUploadSolid } from "react-icons/lia";
// import { useLocation } from 'react-router-dom';
// import { Computer } from 'lucide-react';
// import SearchModal from './SearchModal.jsx';
// import { openSearch, selectIsSearchOpen } from '../redux/headerSlice.js';

// const Header = () => {
//     const [isFixed, setIsFixed] = useState(false);
//     const [activeItem, setActiveItem] = useState('');
//     const [activeDropdown, setActiveDropdown] = useState('');
//     const [userDatafromOauth, setUserDataFromOauth] = useState(null);
//     const [userExistsState, setUserExistsState] = useState(false);
//     const [searchIs, setSearchIs] = useState(true);

//     const location = useLocation();
//     const webmaster = useSelector((state) => state.user)
//     const facultstaff = useSelector((state) => state.facultyuser)
//     const phduser = useSelector((state) => state.phduser)
//     const staffuser = useSelector((state) => state.staffuser)
//     const postdocuser = useSelector((state) => state.postdocuser)

//     const dispatch = useDispatch();
//     const navigateTo = useNavigate();
//     const statecsc = useSelector((state) => state.statecsc)
//     const userfromwebmaster = useSelector((state) => state.user);
//     const searchTriggerRef = useRef(null);
//     const isSearchOpen = useSelector(selectIsSearchOpen);

//     useEffect(() => {
//         const handleScroll = () => {
//             if (window.scrollY > 600 && !isFixed) {
//                 setIsFixed(true);
//             } else if (window.scrollY <= 400 && isFixed) {
//                 setIsFixed(false);
//             }
//         };

//         window.addEventListener('scroll', handleScroll);
//         return () => {
//             window.removeEventListener('scroll', handleScroll);
//         };
//     }, [isFixed]);

//     const handleItemClick = (itemName) => {
//         setActiveItem(itemName);
//     };

//     const handleDropdownClick = (dropdownName) => {
//         setActiveDropdown(dropdownName);
//     };

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const response = await fetch(`${Base_Url}/admin-user-data`, {
//                     method: "GET",
//                     credentials: "include",
//                 });

//                 if (!response.ok) {
//                     throw new Error(`HTTP error! Status: ${response.status}`);
//                 }
//                 const data = await response.json();

//                 if (data) {
//                     const userDetailsResponse = await fetch(
//                         `${Base_Url}/webmasters/user/${data.user_id}`,
//                         {
//                             method: "GET",
//                         }
//                     );

//                     const userDetails = await userDetailsResponse.json();

//                     if (typeof userDetails === 'object' && userDetails !== null && !userDetails.error) {
//                         setUserDataFromOauth(userDetails);
//                         setUserExistsState(true);
//                         dispatch(setUserData({
//                             userData: userDetails,
//                             userExists: true,
//                             isAdmin: true,
//                         }));
//                     } else {
//                         const lowerCategory = data.category;
//                         const lowerDepartment = data.department;
//                         const userid = data.user_id;
//                         if (lowerCategory === "faculty" && lowerDepartment === "cc") {
//                             dispatch(setFacultyProfileData({
//                                 facultyprofileData: data,
//                                 facultyprofileExists: true,
//                                 isfacultyProfileAdmin: true,
//                             }));
//                         } else if (lowerCategory === "staff" && lowerDepartment === "cc") {
//                             dispatch(setStaffData({
//                                 staffData: data,
//                                 staffExists: true,
//                                 isStaffAdmin: true,
//                             }));
//                         } else {
//                             handleUnauthorizedAccess();
//                             toast.error("You are not authorized to access this application.");
//                         }
//                     }
//                 }
//             } catch (error) {
//                 console.error("Authentication error:", error);
//                 handleUnauthorizedAccess();
//             }
//         };

//         const handleUnauthorizedAccess = () => {
//             setUserExistsState(false);
//             setUserDataFromOauth(null);
//             dispatch(setUserData({
//                 userData: null,
//                 userExists: false,
//                 isAdmin: false,
//             }));
//         };

//         fetchData();
//     }, [dispatch]);

//     const handleDropdownToggle = (dropdown) => {
//         setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
//     };

//     const logoutUser = async () => {
//         try {
//             const response = await fetch(`${Base_Url}/admin-logout`, {
//                 method: "GET",
//                 credentials: "include",
//             });

//             if (response.ok) {
//                 navigateTo("/")
//                 window.location.reload();
//             } else {
//                 window.location.reload();
//             }
//         } catch (error) {
//             window.location.reload();
//         }
//     };
// const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);


// useEffect(() => {
//   const handleResize = () => {
//     setIsSmallScreen(window.innerWidth < 768);
//   };
  
//   window.addEventListener('resize', handleResize);
//   return () => window.removeEventListener('resize', handleResize);
// }, []);
//     return (
//         <div>
//      {
//        isSearchOpen === false ? (
//          <div
//            className={`header top-header ${isFixed ? 'fixed' : ''}`}
//            style={{
//              background: '#c21717',
//              color: '#ffffff',
//              fontFamily: 'Arial, sans-serif',
//              fontSize: '14px',
//              padding: '2px 20px',
//              height: isSmallScreen ? "auto" : "32px"
//            }}
//          >
//            <div className="topbar bg-theme-colored2">
//              <div className="container">
//                <div className="row">
//                  <div className={isSmallScreen ? "col-12" : "col-lg-10 col-md-12 xs-mb-12"}>
//                    <div className={`topbar-call ${isSmallScreen ? 'text-center' : 'text-center text-md-left'}`}>
//                      <ul 
//                        className={`${isSmallScreen ? 'd-flex flex-wrap justify-content-center' : 'd-flex justify-content-center align-items-center'}`} 
//                        style={{ 
//                          textDecoration: "none", 
//                          listStyleType: "none", 
//                          padding: 0, 
//                          margin: 0 
//                        }}
//                      >
//                        {isSmallScreen ? (
//                          // Mobile Layout - 3 items per row
//                          <>
//                            <li className="mx-2 mb-2" style={{ width: 'calc(33.33% - 16px)', minWidth: '90px' }}>
//                              <a className='text-decoration-none d-flex align-items-center justify-content-center' href="https://home.iitd.ac.in/" target="_blank">
//                                <span>IITD</span>
//                                <FaExternalLinkSquareAlt className='ms-1' style={{ fontSize: "14px" }} />
//                              </a>
//                            </li>
//                            <li className="mx-2 mb-2" style={{ width: 'calc(33.33% - 16px)', minWidth: '90px' }}>
//                              <span
//                                className="text-decoration-none d-flex align-items-center justify-content-center"
//                                style={{ cursor: 'pointer' }}
//                                onClick={(e) => {
//                                  e.currentTarget.innerHTML = `
//                                    <div class="d-flex align-items-center justify-content-center">
//                                      <svg style="font-size: 14px; margin-right: 4px;" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 512 512">
//                                        <path d="M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"/>
//                                      </svg>
//                                      <span>sysadm@cc.iitd.ac.in</span>
//                                    </div>
//                                  `;
//                                  e.currentTarget.style.cursor = 'auto';
//                                }}
//                              >
//                                <FaEnvelope style={{ fontSize: "14px" }} />
//                                <span className="ms-1">Email</span>
//                              </span>
//                            </li>
//                            <li className="mx-2 mb-2" style={{ width: 'calc(33.33% - 16px)', minWidth: '90px' }}>
//                              <a className='text-decoration-none d-flex align-items-center justify-content-center' href="tel:011-2659-7220">
//                                <FaPhoneSquareAlt className='me-1' style={{ fontSize: "14px" }} />
//                                <span>Phone</span>
//                              </a>
//                            </li>
                           
//                            <li className="mx-2 mb-2" style={{ width: 'calc(33.33% - 16px)', minWidth: '90px' }}>
//                              <Link to="/services-network" className='text-decoration-none text-white d-flex align-items-center justify-content-center'>
//                                <FaWifi className='me-1' style={{ fontSize: "14px" }} />
//                                <span>Network</span>
//                              </Link>
//                            </li>
//                            <li className="mx-2 mb-2" style={{ width: 'calc(33.33% - 16px)', minWidth: '90px' }}>
//                              <Link to="/services-web-services" className='text-decoration-none text-white d-flex align-items-center justify-content-center'>
//                                <FaGlobe className='me-1' style={{ fontSize: "14px" }} />
//                                <span>Web</span>
//                              </Link>
//                            </li>
//                            <li className="mx-2 mb-2" style={{ width: 'calc(33.33% - 16px)', minWidth: '90px' }}>
//                              <Link to="/services-software" className='text-decoration-none text-white d-flex align-items-center justify-content-center'>
//                                <FaCogs className='me-1' style={{ fontSize: "14px" }} />
//                                <span>Software</span>
//                              </Link>
//                            </li>
//                            <li className="mx-2 mb-2" style={{ width: 'calc(33.33% - 16px)', minWidth: '90px' }}>
//                              <Link to="https://baadal.iitd.ac.in/baadal" className='text-decoration-none text-white d-flex align-items-center justify-content-center'>
//                                <FaCloud   className='me-1' style={{ fontSize: "14px" }} />
//                                <span>Baadal</span>
//                              </Link>
//                            </li>
                           
//                            <li className="mx-2 mb-2" style={{ width: 'calc(33.33% - 16px)', minWidth: '90px' }}>
//                              <a
//                                href="https://supercomputing.iitd.ac.in/"
//                                className='text-decoration-none text-white d-flex align-items-center justify-content-center'
//                                target="_blank"
//                                rel="noopener noreferrer"
//                              >
//                                <FaServer className='me-1' style={{ fontSize: "14px" }} />
//                                <span>HPC</span>
//                              </a>
//                            </li>
//                          </>
//                        ) : (
//                          // Desktop Layout - original layout
//                          <>
//                            <li style={{ marginBottom: "10px" }} className='me-4 mb-0 mt-1 text-white'>
//                              <a className='text-decoration-none' href="https://home.iitd.ac.in/" target="_blank">IITD Website <FaExternalLinkSquareAlt className='me-2' style={{ fontSize: "17px" }} /></a>
//                            </li>
//                            <li style={{ marginBottom: "10px" }} className='me-4 mb-0 mt-1 text-white'>
//                              <span
//                                className="text-decoration-none d-flex align-items-center"
//                                style={{ cursor: 'pointer' }}
//                                onClick={(e) => {
//                                  e.currentTarget.innerHTML = `
//                                    <div class="d-flex align-items-center">
//                                      <svg style="font-size: 17px; margin-right: 8px;" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 512 512">
//                                        <path d="M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"/>
//                                      </svg>
//                                      <span>sysadm@cc.iitd.ac.in</span>
//                                    </div>
//                                  `;
//                                  e.currentTarget.style.cursor = 'auto';
//                                }}
//                              >
//                                <FaEnvelope style={{ fontSize: "17px" }} />
//                              </span>
//                            </li>
//                            <li style={{ marginBottom: "10px" }} className='me-4 mb-0 mt-1 text-white'>
//                              <FaPhoneSquareAlt className='me-2' style={{ fontSize: "17px", textDecoration: "none" }} />
//                              <a className='text-decoration-none' style={{ textDecoration: "none" }} href="tel:011-2659-7220">
//                                <span>011-2659-7220</span>
//                              </a>
//                            </li>
//                            <li style={{ marginBottom: "10px" }} className='me-4 mb-0 mt-1 text-white'>
//                              <FaWifi className='me-2' style={{ fontSize: "17px" }} />
//                              <Link to="/services-network" className='text-decoration-none text-white'>
//                                <span>Networking</span>
//                              </Link>
//                            </li>
//                            <li style={{ marginBottom: "10px" }} className='me-4 mb-0 mt-1 text-white'>
//                              <FaGlobe className='me-2' style={{ fontSize: "17px" }} />
//                              <Link to="/services-web-services" className='text-decoration-none text-white'>
//                                <span>Web Services</span>
//                              </Link>
//                            </li>
//                            <li style={{ marginBottom: "10px" }} className='me-4 mb-0 mt-1 text-white'>
//                              <FaCogs className='me-2' style={{ fontSize: "17px" }} />
//                              <Link to="/services-software" className='text-decoration-none text-white'>
//                                <span>Software</span>
//                              </Link>
//                            </li>
//                            <li style={{ marginBottom: "10px" }} className='me-4 mb-0 mt-1 text-white'>
//                              <FaCloud  className='me-2' style={{ fontSize: "17px" }} />
//                              <Link to="https://baadal.iitd.ac.in/baadal" className='text-decoration-none text-white'>
//                                <span>Baadal</span>
//                              </Link>
//                            </li>
//                            <li style={{ marginBottom: "10px" }} className='me-4 mb-0 mt-1 text-white d-flex align-items-center'>
//                              <FaServer className='me-2' style={{ fontSize: "17px" }} />
//                              <a
//                                href="https://supercomputing.iitd.ac.in/"
//                                className='text-decoration-none text-white'
//                                target="_blank"
//                                rel="noopener noreferrer"
//                              >
//                                <span>HPC</span>
//                              </a>
//                            </li>
//                            <li style={{ marginBottom: "10px" }} className='me-4 mb-0 mt-1 text-white'>
//                              <FaLightbulb  className='me-2' style={{ fontSize: "17px" }} />
//                              <Link to="/howto" className='text-decoration-none text-white'>
//                                <span>How To</span>
//                              </Link>
//                            </li>
//                          </>
//                        )}
//                      </ul>
//                    </div>
//                  </div>
//                  {!isSmallScreen && (
//                    <div className="col-lg-2 col-md-6">
//                      <div className="topbar-social text-center text-md-right">
//                        <ul>
//                        </ul>
//                      </div>
//                    </div>
//                  )}
//                </div>
//              </div>
//            </div>
//          </div>
//        ) : ""
//      }
//             <nav className={`navbar navbar-expand-lg header p-0 bottom-header mainHeader ${isFixed ? 'fixed' : ''}`}
//                 style={{
//                     backgroundColor: 'light',
//                     justifyContent: 'space-around',
//                 }}
//             >
//                 <div className="container-fluid justify-content-lg-around">
//                     <Link className="navbar-brand" to="/">
//                         <img
//                             src={Logo}
//                             alt="Logo"
//                             height="76px"
//                             className="d-inline-block align-top"
//                         />
//                     </Link>
//                     <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
//                         <span className="navbar-toggler-icon"></span>
//                     </button>
//                     <div className="collapse navbar-collapse" id="navbarNav">
//                         <ul className="navbar-nav ms-auto">
//                             {/* Home Link - Simplified */}
//                             <li className="nav-item">
//                                 <NavLink
//                                     className={({ isActive }) => 
//                                         `nav-link homeicons ${isActive ? 'activehomeactivated' : 'activehome'}`
//                                     }
//                                     onClick={() => handleDropdownToggle('Home')}
//                                     to="/"
//                                     end
//                                 >
//                                     <FaHome style={{ marginBottom: "2px", fontSize: "larger" }} color='#c21717' />
//                                 </NavLink>
//                             </li>

//                             {/* Services Dropdown */}
//                             <li className="nav-item dropdown">
//                                 <NavLink
//                                     to="/services"
//                                     className={`nav-link dropdown-toggle ${activeDropdown === 'services' ? 'active' : ''}`}
//                                     onClick={() => handleDropdownToggle('services')}
//                                     role="button"
//                                     aria-expanded={activeDropdown === 'services' ? 'true' : 'false'}
//                                 >
//                                     Services  <IoIosArrowDown />
//                                 </NavLink>
//                                 <ul className="dropdown-menu">
//                                     <li><NavLink className={`dropdown-item ${activeItem === 'software' ? 'active' : ''}`} to="/services-software" onClick={() => handleItemClick('software')}>Software</NavLink></li>
//                                     <li><NavLink className={`dropdown-item ${activeItem === 'network' ? 'active' : ''}`} to="/services-network" onClick={() => handleItemClick('network')}>Network</NavLink></li>
//                                     <li><NavLink className={`dropdown-item ${activeItem === 'webservices' ? 'active' : ''}`} to="/services-web-services" onClick={() => handleItemClick('webservices')}>Web Services</NavLink></li>
//                                     <li><NavLink className={`dropdown-item ${activeItem === 'useradmin' ? 'active' : ''}`} to="/services-user-admin-infra" onClick={() => handleItemClick('useradmin')}>User Admin & Infra</NavLink></li>
//                                     <li><NavLink className={`dropdown-item ${activeItem === 'hpc' ? 'active' : ''}`} to="https://supercomputing.iitd.ac.in/" onClick={() => handleItemClick('hpc')}>HPC</NavLink></li>
//                                     <li><NavLink className={`dropdown-item ${activeItem === 'cloudcomp' ? 'active' : ''}`} to="https://baadal.iitd.ac.in/baadal" onClick={() => handleItemClick('cloudcomp')}>Cloud Computing</NavLink></li>
//                                     <li><NavLink className={`dropdown-item ${activeItem === 'erp' ? 'active' : ''}`} to="/services-erp" onClick={() => handleItemClick('erp')}>ERP</NavLink></li>
//                                 </ul>
//                             </li>

//                             {/* People Dropdown */}
//                             {/* <li className="nav-item dropdown">
//                                 <NavLink
//                                     to="/people"
//                                     className={`nav-link dropdown-toggle ${activeDropdown === 'Academics' ? 'active' : ''}`}
//                                     role="button"
//                                     aria-expanded={activeDropdown === 'Academics' ? 'true' : 'false'}
//                                     onClick={() => handleDropdownToggle('Academics')}
//                                 >
//                                     People <IoIosArrowDown />
//                                 </NavLink>
//                                 <ul className="dropdown-menu">
//                                     {userfromwebmaster.userExists || statecsc.userState === 0 ? (
//                                         <li>
//                                             <NavLink
//                                                 className={`dropdown-item ${activeItem === 'peoplemanage' ? 'active' : ''}`}
//                                                 to="/people-manage"
//                                                 onClick={() => handleItemClick('peoplemanage')}
//                                             >
//                                                 People Manage <MdManageAccounts />
//                                             </NavLink>
//                                         </li>
//                                     ) : null}
//                                     <li><NavLink className={`dropdown-item ${activeItem === 'Faculty' ? 'active' : ''}`} to="/faculty" onClick={() => handleItemClick('Faculty')}>Academic</NavLink></li>
//                                     <li><NavLink className={`dropdown-item ${activeItem === 'Staff' ? 'active' : ''}`} to="/staff" onClick={() => handleItemClick('Staff')}>Non Academic</NavLink></li>
//                                     <li><NavLink className={`dropdown-item ${activeItem === 'Ex-Faculty Members' ? 'active' : ''}`} to="/ex-faculty" onClick={() => handleItemClick('Ex-Faculty Members')}>Superannuated/Resigned</NavLink></li>
//                                 </ul>
//                             </li> */}

//                   <li className="nav-item dropdown">
//   <NavLink
//     to="/people"
//     className={`nav-link dropdown-toggle ${activeDropdown === 'People' ? 'active' : ''}`}
//     role="button"
//     aria-expanded={activeDropdown === 'People' ? 'true' : 'false'}
//     onClick={() => handleDropdownToggle('People')}
//   >
//     People <IoIosArrowDown />
//   </NavLink>
//   <ul className="dropdown-menu">
//     {userfromwebmaster.userExists || statecsc.userState === 0 ? (
//       <li>
//         <NavLink
//           className={`dropdown-item ${activeItem === 'peoplemanage' ? 'active' : ''}`}
//           to="/people-manage"
//           onClick={() => handleItemClick('peoplemanage')}
//         >
//           People Manage <MdManageAccounts />
//         </NavLink>
//       </li>
//     ) : null}
//     <li><NavLink className={`dropdown-item ${activeItem === 'Faculty' ? 'active' : ''}`} to="/academic" onClick={() => handleItemClick('Faculty')}>Academic</NavLink></li>
//     <li><NavLink className={`dropdown-item ${activeItem === 'Staff' ? 'active' : ''}`} to="/non-academic" onClick={() => handleItemClick('Staff')}>Non Academic</NavLink></li>
//     <li><NavLink className={`dropdown-item ${activeItem === 'non-academic' ? 'active' : ''}`} to="/ex-head" onClick={() => handleItemClick('non-academic')}>Ex Head</NavLink></li>
//     <li><NavLink className={`dropdown-item ${activeItem === 'ird' ? 'active' : ''}`} to="/ird" onClick={() => handleItemClick('ird')}>IRD</NavLink></li>
//     <li><NavLink className={`dropdown-item ${activeItem === 'os' ? 'active' : ''}`} to="/os" onClick={() => handleItemClick('os')}>Out Sourced</NavLink></li>
    
//     {/* Nested dropdown for Superannuated/Resigned */}
//     <li className="dropdown-submenu">
//       <span className="dropdown-item dropdown-toggle">
//         Superannuated/Resigned <IoIosArrowForward className="dropdown-arrow" />
//       </span>
//       <ul className="dropdown-menu nested-dropdown">
//         <li>
//           <NavLink 
//             className={`dropdown-item ${activeItem === 'Ex-Faculty Members' ? 'active' : ''}`} 
//             to="/ex-academic" 
//             onClick={() => handleItemClick('Ex-Faculty Members')}
//           >
//             Academic
//           </NavLink>
//         </li>
//         <li>
//           <NavLink 
//             className={`dropdown-item ${activeItem === 'Ex-Staff Members' ? 'active' : ''}`} 
//             to="/ex-non-academic" 
//             onClick={() => handleItemClick('Ex-Staff Members')}
//           >
//             Non Academic
//           </NavLink>
//         </li>
//       </ul>
//     </li>
//   </ul>
// </li>
//                                     {/* <li><NavLink className={`dropdown-item ${activeItem === 'ex-Staff' ? 'active' : ''}`} to="/ex-staff" onClick={() => handleItemClick('ex-Staff')}>Non Academic</NavLink></li> */}

//                             {/* Quick Access Dropdown - Fixed */}
//                             {/* <li className="nav-item dropdown">
//                             <NavLink
//     className="nav-link dropdown-item"
// >
//                                     Quick Access <IoIosArrowDown />
//                                 </NavLink>
//                                 <ul className="dropdown-menu">
//                                     <li>
//                                         <NavLink
//                                             className={`dropdown-item ${activeItem === 'howto' ? 'active' : ''}`}
//                                             to="/howto"
//                                             onClick={() => handleItemClick('howto')}
//                                         >
//                                             "How To?" Zone
//                                         </NavLink>
//                                     </li>
//                                     <li>
//                                         <NavLink
//                                             className={`dropdown-item ${activeItem === 'getting' ? 'active' : ''}`}
//                                             to="/getting-started"
//                                             onClick={() => handleItemClick('getting')}
//                                         >
//                                             Getting Started
//                                         </NavLink>
//                                     </li>
//                                     <li>
//                                         <a
//                                             className={`dropdown-item ${activeItem === 'MRTG' ? 'active' : ''}`}
//                                             href="http://healthgraphs.iitd.ac.in/mrtg/"
//                                             onClick={() => handleItemClick('MRTG')}
//                                             target="_blank"
//                                             rel="noopener noreferrer"
//                                         >
//                                             Healthgraphs (MRTG) <FaExternalLinkAlt />
//                                         </a>
//                                     </li>
//                                     <li>
//                                         <a
//                                             className={`dropdown-item ${activeItem === 'rrd' ? 'active' : ''}`}
//                                             href="http://healthgraphs.iitd.ac.in/cgi-bin/routers2.cgi"
//                                             onClick={() => handleItemClick('rrd')}
//                                             target="_blank"
//                                             rel="noopener noreferrer"
//                                         >
//                                             Healthgraphs (RRD) <FaExternalLinkAlt />
//                                         </a>
//                                     </li>
//                                     <li>
//                                         <a
//                                             className={`dropdown-item ${activeItem === 'tenders' ? 'active' : ''}`}
//                                             href="https://home.iitd.ac.in/tenders.php"
//                                             onClick={() => handleItemClick('tenders')}
//                                             target="_blank"
//                                             rel="noopener noreferrer"
//                                         >
//                                             Tenders (IITD) <FaExternalLinkAlt />
//                                         </a>
//                                     </li>
//                                 </ul>
//                             </li> */}
//                             {/* Quick Access Dropdown - Fixed */}
// <li className="nav-item dropdown">
//     <a
//         className="nav-link dropdown-toggle"
//         href="#"
//         role="button"
//         data-bs-toggle="dropdown"
//         aria-expanded="false"
//     >
//         Quick Access <IoIosArrowDown />
//     </a>
//     <ul className="dropdown-menu">
//         <li>
//             <NavLink
//                 className="dropdown-item"
//                 to="/howto"
//             >
//                 "How To?" Zone
//             </NavLink>
//         </li>
//         <li>
//             <NavLink
//                 className="dropdown-item"
//                 to="/getting-started"
//             >
//                 Getting Started
//             </NavLink>
//         </li>
//         <li>
//             <a
//                 className="dropdown-item"
//                 href="http://healthgraphs.iitd.ac.in/mrtg/"
//                 target="_blank"
//                 rel="noopener noreferrer"
//             >
//                 Healthgraphs (MRTG) <FaExternalLinkAlt />
//             </a>
//         </li>
//         {/* <li>
//             <a
//                 className="dropdown-item"
//                 href="http://healthgraphs.iitd.ac.in/cgi-bin/routers2.cgi"
//                 target="_blank"
//                 rel="noopener noreferrer"
//             >
//                 Healthgraphs (RRD) <FaExternalLinkAlt />
//             </a>
//         </li> */}
//         <li>
//             <a
//                 className="dropdown-item"
//                 href="https://home.iitd.ac.in/tenders.php"
//                 target="_blank"
//                 rel="noopener noreferrer"
//             >
//                 Tenders (IITD) <FaExternalLinkAlt />
//             </a>
//         </li>
//     </ul>
// </li>

//                             {/* Careers Link */}
//                             <li className="nav-item">
//                                 <NavLink className={`nav-link-careers nav-link ${activeDropdown === 'Careers' ? 'active' : ''}`} to="/careers" onClick={() => handleDropdownClick('Careers')}>
//                                     Careers
//                                 </NavLink>
//                             </li>

//                             {/* Contact Link */}
//                             <li className="nav-item">
//                                 <NavLink className={`nav-link-contact nav-link ${activeDropdown === 'Contact' ? 'active' : ''}`} to="/contact" onClick={() => handleDropdownClick('Contact')}>
//                                     Contact
//                                 </NavLink>
//                             </li>
                         

//                             {/* Search */}
//                             <li className="nav-item" onClick={() => dispatch(openSearch())}>
//                             </li>
//                             <SearchModal triggerRef={searchTriggerRef} />

//                             {/* User Dropdown */}
//                             <li className="nav-item dropdown d-flex justify-content-center align-items-center logindropdown">
//                                 <a
//                                     className="nav-link dropdown-toggle p-0 logindropdowna"
//                                     href="#"
//                                     role="button"
//                                     data-bs-toggle="dropdown"
//                                     aria-expanded="false"
//                                 >
//                                     {webmaster && webmaster?.userData?.name ? (
//                                         Array.isArray(webmaster) ? (
//                                             webmaster.length > 0 ? (
//                                                 webmaster.map((elem, index) => (
//                                                     <React.Fragment key={index}>
//                                                         {elem?.name || 'No Name'}
//                                                         <br />
//                                                         <span style={{ fontSize: "11px" }}>({elem?.user_id || 'No ID'})</span>
//                                                         <IoIosArrowDown />
//                                                     </React.Fragment>
//                                                 ))
//                                             ) : (
//                                                 <span>No Webmaster Data</span>
//                                             )
//                                         ) : (
//                                             <React.Fragment>
//                                                 <span className="user-dropdown__manage user-dropdown__manage--disabled"
//                                                     aria-disabled="true"
//                                                     style={{ pointerEvents: 'none', }}>
//                                                     Manage <MdManageAccounts />
//                                                     <IoIosArrowDown className="user-dropdown__arrow" />
//                                                 </span>
//                                             </React.Fragment>
//                                         )
//                                     ) : (
//                                         (statecsc.userState === 1 || statecsc.userState === 2) &&
//                                             (facultstaff?.facultyprofileExists && facultstaff?.facultyprofileData?.name !== "" ||
//                                                 staffuser?.staffExists && staffuser?.staffData?.name !== "") ? (
//                                             <React.Fragment >
//                                                 <span className='text-dark'>
//                                                     {staffuser?.staffData?.name || facultstaff?.facultyprofileData?.name} <MdManageAccounts />
//                                                 </span>
//                                                 <IoIosArrowDown className='text-dark' />
//                                             </React.Fragment>
//                                         ) : null
//                                     )}
//                                 </a>
//                                 <ul className="dropdown-menu dropdown-menus">
//                                     {webmaster && webmaster?.userData?.name && (
//                                         <>
//                                             <li className="border-bottom ">
//                                                 <span className="text-dark">
//                                                     {webmaster?.userData?.name || 'No Name'}
//                                                 </span>
//                                                 <span className="text-dark" style={{ fontSize: "11px" }}>
//                                                     ({webmaster?.userData?.userid || 'No ID'})
//                                                 </span>
//                                             </li>
//                                             <li className="border-bottom">
//                                                 <NavLink
//                                                     to="/uploads"
//                                                     style={{
//                                                         color: "blue",
//                                                         borderBottom: "0px solid",
//                                                         textDecoration: "none"
//                                                     }}
//                                                 >
//                                                     <span style={{ color: "#c21717", fontSize: "15px" }}>
//                                                         Uploads <LiaFileUploadSolid className="ms-2" />
//                                                     </span>
//                                                 </NavLink>
//                                             </li>
//                                             <li className="border-bottom">
//                                                 <NavLink
//                                                     to="/manage-users"
//                                                     style={{
//                                                         color: "blue",
//                                                         borderBottom: "0px solid",
//                                                         textDecoration: "none"
//                                                     }}
//                                                 >
//                                                     <span style={{ color: "#c21717", fontSize: "15px" }}>
//                                                         Manage Users <FaUserEdit className="ms-2" />
//                                                     </span>
//                                                 </NavLink>
//                                             </li>
//                                             <li className="border-bottom">
//                                                 <NavLink
//                                                     to="/add-routes"
//                                                     style={{
//                                                         color: "blue",
//                                                         borderBottom: "0px solid",
//                                                         textDecoration: "none"
//                                                     }}
//                                                 >
//                                                     <span style={{ color: "#c21717", fontSize: "15px" }}>
//                                                         Add Routes <TbRouteSquare2 className="ms-2" />
//                                                     </span>
//                                                 </NavLink>
//                                             </li>
//                                         </>
//                                     )}
//                                     <li className="border-bottom">
//                                         <span
//                                             onClick={() => logoutUser()}
//                                             style={{ color: "#c21717", cursor: "pointer" }}
//                                         >
//                                             Logout <FiLogOut className="ms-5" />
//                                         </span>
//                                     </li>
//                                 </ul>
//                             </li>
//                         </ul>
//                     </div>
//                 </div>
//             </nav>
//         </div>
//     );
// };

// export default Header;


import React, { useState, useEffect, useRef } from 'react';
import './Header.css';
import { FaCogs, FaGlobe, FaHome, FaUserEdit, FaWifi, FaExternalLinkSquareAlt, FaEnvelope, FaPhoneSquareAlt, FaUser, FaServer, FaSearch, FaCloud, FaLightbulb, FaBriefcase } from "react-icons/fa";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { resetUser, selectUserExists, setUserData } from "../redux/userSlice";
import { setFacultyProfileData } from '../redux/facultySlice';
import { setStaffData } from '../redux/staffSlice';
import { toast } from 'react-toastify';
import { Base_Url } from '../config.js';
import Logo from "../Assests/logo.png"
import { MdManageAccounts } from "react-icons/md";
import { FiLogOut } from 'react-icons/fi';
import {  TbRouteSquare2 } from "react-icons/tb";
import { FaExternalLinkAlt } from "react-icons/fa";
import { LiaFileUploadSolid } from "react-icons/lia";
import { useLocation } from 'react-router-dom';

import SearchModal from './SearchModal.jsx';
import { openSearch, selectIsSearchOpen } from '../redux/headerSlice.js';
import { Briefcase } from 'lucide-react';

const Header = () => {
    const [isFixed, setIsFixed] = useState(false);
    const [activeItem, setActiveItem] = useState('');
    const [activeDropdown, setActiveDropdown] = useState('');
    const [userDatafromOauth, setUserDataFromOauth] = useState(null);
    const [userExistsState, setUserExistsState] = useState(false);
    const [searchIs, setSearchIs] = useState(true);

    const location = useLocation();
    const webmaster = useSelector((state) => state.user)
    const facultstaff = useSelector((state) => state.facultyuser)
    const phduser = useSelector((state) => state.phduser)
    const staffuser = useSelector((state) => state.staffuser)
    const postdocuser = useSelector((state) => state.postdocuser)

    const dispatch = useDispatch();
    const navigateTo = useNavigate();
    const statecsc = useSelector((state) => state.statecsc)
    const userfromwebmaster = useSelector((state) => state.user);
    const searchTriggerRef = useRef(null);
    const isSearchOpen = useSelector(selectIsSearchOpen);



    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 600 && !isFixed) {
                setIsFixed(true);
            } else if (window.scrollY <= 400 && isFixed) {
                setIsFixed(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isFixed]);

    const handleItemClick = (itemName) => {
        setActiveItem(itemName);
    };

    const handleDropdownClick = (dropdownName) => {
        setActiveDropdown(dropdownName);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${Base_Url}/admin-user-data`, {
                    method: "GET",
                    credentials: "include",
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = await response.json();

                if (data) {
                    const userDetailsResponse = await fetch(
                        `${Base_Url}/webmasters/user/${data.user_id}`,
                        {
                            method: "GET",
                        }
                    );

                    const userDetails = await userDetailsResponse.json();

                    if (typeof userDetails === 'object' && userDetails !== null && !userDetails.error) {
                        setUserDataFromOauth(userDetails);
                        setUserExistsState(true);
                        dispatch(setUserData({
                            userData: userDetails,
                            userExists: true,
                            isAdmin: true,
                        }));
                    } else {
                        const lowerCategory = data.category;
                        const lowerDepartment = data.department;
                        const userid = data.user_id;
                        if (lowerCategory === "faculty" && lowerDepartment === "cc") {
                            dispatch(setFacultyProfileData({
                                facultyprofileData: data,
                                facultyprofileExists: true,
                                isfacultyProfileAdmin: true,
                            }));
                        } else if (lowerCategory === "staff" && lowerDepartment === "cc") {
                            dispatch(setStaffData({
                                staffData: data,
                                staffExists: true,
                                isStaffAdmin: true,
                            }));
                        } else {
                            handleUnauthorizedAccess();
                            toast.error("You are not authorized to access this application.");
                        }
                    }
                }
            } catch (error) {
                console.error("Authentication error:", error);
                handleUnauthorizedAccess();
            }
        };

        const handleUnauthorizedAccess = () => {
            setUserExistsState(false);
            setUserDataFromOauth(null);
            dispatch(setUserData({
                userData: null,
                userExists: false,
                isAdmin: false,
            }));
        };

        fetchData();
    }, [dispatch]);

    const handleDropdownToggle = (dropdown) => {
        setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
    };

    const logoutUser = async () => {
        try {
            const response = await fetch(`${Base_Url}/admin-logout`, {
                method: "GET",
                credentials: "include",
            });

            if (response.ok) {
                navigateTo("/")
                window.location.reload();
            } else {
                window.location.reload();
            }
        } catch (error) {
            window.location.reload();
        }
    };
    
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 768);
        };
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div>
            {
                isSearchOpen === false ? (
                    // <div
                    //     className={`header top-header ${isFixed ? 'fixed' : ''}`}
                    //     style={{
                    //         background: '#c21717',
                    //         color: '#ffffff',
                    //         fontFamily: 'Arial, sans-serif',
                    //         fontSize: '14px',
                    //         padding: '2px 20px',
                    //         height: isSmallScreen ? "auto" : "32px"
                    //     }}
                    // >
                    //     <div className="topbar bg-theme-colored2">
                    //         <div className="container-fluid p-0">
                    //             <div className="row">
                    //                 <div className={isSmallScreen ? "col-12" : "col-lg-12 col-md-12 xs-mb-12 p-0"}>
                    //                     <div className={`topbar-call ${isSmallScreen ? 'text-center' : 'text-center text-md-left'}`}>
                    //                         <ul 
                    //                             className={`${isSmallScreen ? 'd-flex flex-wrap justify-content-center' : 'd-flex justify-content-center align-items-center'}`} 
                    //                             style={{ 
                    //                                 textDecoration: "none", 
                    //                                 listStyleType: "none", 
                    //                                 padding: 0, 
                    //                                 margin: 0 
                    //                             }}
                    //                         >
                    //                             {isSmallScreen ? (
                    //                                 // Mobile Layout - 3 items per row
                    //                                 <>
                    //                                  <li className="mx-2 mb-2" style={{ width: 'calc(33.33% - 16px)', minWidth: '90px' }}>
                    //                                         <a
                    //                                             href="https://eadmin.iitd.ac.in/"
                    //                                             className='text-decoration-none text-white d-flex align-items-center justify-content-center'
                    //                                             target="_blank"
                    //                                             rel="noopener noreferrer"
                    //                                         >
                    //                                             <FaBriefcase className='me-1' style={{ fontSize: "14px" }} />
                    //                                             <span>ERP</span>
                    //                                         </a>
                    //                                     </li>
                    //                                     <li className="mx-2 mb-2" style={{ width: 'calc(33.33% - 16px)', minWidth: '90px' }}>
                    //                                         <a className='text-decoration-none d-flex align-items-center justify-content-center' href="https://home.iitd.ac.in/" target="_blank">
                    //                                             <span>IITD</span>
                    //                                             <FaExternalLinkSquareAlt className='ms-1' style={{ fontSize: "14px" }} />
                    //                                         </a>
                    //                                     </li>
                    //                                     <li className="mx-2 mb-2" style={{ width: 'calc(33.33% - 16px)', minWidth: '90px' }}>
                    //                                         <span
                    //                                             className="text-decoration-none d-flex align-items-center justify-content-center"
                    //                                             style={{ cursor: 'pointer' }}
                    //                                             onClick={(e) => {
                    //                                                 e.currentTarget.innerHTML = `
                    //                                                     <div class="d-flex align-items-center justify-content-center">
                    //                                                         <svg style="font-size: 14px; margin-right: 4px;" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 512 512">
                    //                                                             <path d="M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"/>
                    //                                                         </svg>
                    //                                                         <span>sysadm@cc.iitd.ac.in</span>
                    //                                                     </div>
                    //                                                 `;
                    //                                                 e.currentTarget.style.cursor = 'auto';
                    //                                             }}
                    //                                         >
                    //                                             <FaEnvelope style={{ fontSize: "14px" }} />
                    //                                             <span className="ms-1">Email</span>
                    //                                         </span>
                    //                                     </li>
                    //                                     <li className="mx-2 mb-2" style={{ width: 'calc(33.33% - 16px)', minWidth: '90px' }}>
                    //                                         <a className='text-decoration-none d-flex align-items-center justify-content-center' href="tel:011-2659-7220">
                    //                                             <FaPhoneSquareAlt className='me-1' style={{ fontSize: "14px" }} />
                    //                                             <span>Phone</span>
                    //                                         </a>
                    //                                     </li>
                                                        
                    //                                     <li className="mx-2 mb-2" style={{ width: 'calc(33.33% - 16px)', minWidth: '90px' }}>
                    //                                         <Link to="/services-network" className='text-decoration-none text-white d-flex align-items-center justify-content-center'>
                    //                                             <FaWifi className='me-1' style={{ fontSize: "14px" }} />
                    //                                             <span>Network</span>
                    //                                         </Link>
                    //                                     </li>
                    //                                     <li className="mx-2 mb-2" style={{ width: 'calc(33.33% - 16px)', minWidth: '90px' }}>
                    //                                         <Link to="/services-web-services" className='text-decoration-none text-white d-flex align-items-center justify-content-center'>
                    //                                             <FaGlobe className='me-1' style={{ fontSize: "14px" }} />
                    //                                             <span>Web</span>
                    //                                         </Link>
                    //                                     </li>
                    //                                     <li className="mx-2 mb-2" style={{ width: 'calc(33.33% - 16px)', minWidth: '90px' }}>
                    //                                         <Link to="/services-software" className='text-decoration-none text-white d-flex align-items-center justify-content-center'>
                    //                                             <FaCogs className='me-1' style={{ fontSize: "14px" }} />
                    //                                             <span>Software</span>
                    //                                         </Link>
                    //                                     </li>
                    //                                     <li className="mx-2 mb-2" style={{ width: 'calc(33.33% - 16px)', minWidth: '90px' }}>
                    //                                         <Link to="https://baadal.iitd.ac.in/baadal" className='text-decoration-none text-white d-flex align-items-center justify-content-center'>
                    //                                             <FaCloud   className='me-1' style={{ fontSize: "14px" }} />
                    //                                             <span>Baadal</span>
                    //                                         </Link>
                    //                                     </li>
                                                        
                    //                                     <li className="mx-2 mb-2" style={{ width: 'calc(33.33% - 16px)', minWidth: '90px' }}>
                    //                                         <a
                    //                                             href="https://supercomputing.iitd.ac.in/"
                    //                                             className='text-decoration-none text-white d-flex align-items-center justify-content-center'
                    //                                             target="_blank"
                    //                                             rel="noopener noreferrer"
                    //                                         >
                    //                                             <FaServer className='me-1' style={{ fontSize: "14px" }} />
                    //                                             <span>HPC</span>
                    //                                         </a>
                    //                                     </li>
                    //                                 </>
                    //                             ) : (
                    //                                 // Desktop Layout - original layout
                    //                                 <>

                                                    
                    //                                     <li style={{ marginBottom: "10px" }} className='me-lg-4  mb-0 mt-1 text-white d-flex align-items-center'>
                    //                                         <FaBriefcase className='me-2' style={{ fontSize: "17px" }} />
                    //                                         <a
                    //                                             href="https://eadmin.iitd.ac.in/"
                    //                                             className='text-decoration-none text-white'
                    //                                             target="_blank"
                    //                                             rel="noopener noreferrer"
                    //                                         >
                    //                                             <span>ERP</span>
                    //                                         </a>
                    //                                     </li> <li style={{ marginBottom: "10px" }} className='me-lg-4 mb-0 me-md-0 mt-1 text-white'>
                    //                                         <FaLightbulb  className='me-2' style={{ fontSize: "17px" }} />
                    //                                         <Link to="/howto" className='text-decoration-none text-white'>
                    //                                             <span>How To</span>
                    //                                         </Link>
                    //                                     </li>
                                                       
                    //                                     <li style={{ marginBottom: "10px" }} className='me-lg-4 mb-0 me-md-0 mt-1 text-white'>
                    //                                         <FaWifi className='me-2' style={{ fontSize: "17px" }} />
                    //                                         <Link to="/services-network" className='text-decoration-none text-white'>
                    //                                             <span>Networking</span>
                    //                                         </Link>
                    //                                     </li>
                    //                                     <li style={{ marginBottom: "10px" }} className='me-lg-4 mb-0 me-md-0 mt-1 text-white'>
                    //                                         <FaGlobe className='me-2' style={{ fontSize: "17px" }} />
                    //                                         <Link to="/services-web-services" className='text-decoration-none text-white'>
                    //                                             <span>Web Services</span>
                    //                                         </Link>
                    //                                     </li>
                    //                                     <li style={{ marginBottom: "10px" }} className='me-lg-4 mb-0 me-md-0 mt-1 text-white'>
                    //                                         <FaCogs className='me-2' style={{ fontSize: "17px" }} />
                    //                                         <Link to="/services-software" className='text-decoration-none text-white'>
                    //                                             <span>Software</span>
                    //                                         </Link>
                    //                                     </li>
                    //                                     <li style={{ marginBottom: "10px" }} className='me-lg-4 mb-0 me-md-0 mt-1 text-white'>
                    //                                         <FaCloud  className='me-2' style={{ fontSize: "17px" }} />
                    //                                         <Link to="https://baadal.iitd.ac.in/baadal" className='text-decoration-none text-white'>
                    //                                             <span>Baadal</span>
                    //                                         </Link>
                    //                                     </li>
                    //                                     <li style={{ marginBottom: "10px" }} className='me-lg-4 me-md-0 mb-0 mt-1 text-white d-flex align-items-center'>
                    //                                         <FaServer className='me-2' style={{ fontSize: "17px" }} />
                    //                                         <a
                    //                                             href="https://supercomputing.iitd.ac.in/"
                    //                                             className='text-decoration-none text-white'
                    //                                             target="_blank"
                    //                                             rel="noopener noreferrer"
                    //                                         >
                    //                                             <span>HPC</span>
                    //                                         </a>
                    //                                     </li>

                    //                                      <li style={{ marginBottom: "10px" }} className='me-4 mb-0 mt-1 text-white'>
                    //                                         <a className='text-decoration-none' href="https://home.iitd.ac.in/" target="_blank">IITD Website <FaExternalLinkSquareAlt className='me-2' style={{ fontSize: "17px" }} /></a>
                    //                                     </li>
                    //                                     <li style={{ marginBottom: "10px" }} className='me-4 mb-0 mt-1 text-white'>
                    //                                         <span
                    //                                             className="text-decoration-none d-flex align-items-center"
                    //                                             style={{ cursor: 'pointer' }}
                    //                                             onClick={(e) => {
                    //                                                 e.currentTarget.innerHTML = `
                    //                                                     <div class="d-flex align-items-center">
                    //                                                         <svg style="font-size: 17px; margin-right: 8px;" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 512 512">
                    //                                                             <path d="M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"/>
                    //                                                         </svg>
                    //                                                         <span>sysadm@cc.iitd.ac.in</span>
                    //                                                     </div>
                    //                                                 `;
                    //                                                 e.currentTarget.style.cursor = 'auto';
                    //                                             }}
                    //                                         >
                    //                                             <FaEnvelope style={{ fontSize: "17px" }} />
                    //                                         </span>
                    //                                     </li>
                    //                                     <li style={{ marginBottom: "10px" }} className='me-4 mb-0 mt-1 text-white'>
                    //                                         <FaPhoneSquareAlt className='me-2' style={{ fontSize: "17px", textDecoration: "none" }} />
                    //                                         <a className='text-decoration-none' style={{ textDecoration: "none" }} href="tel:011-2659-7220">
                    //                                             <span>011-2659-7220</span>
                    //                                         </a>
                    //                                     </li>
                                                        
                                                       
                    //                                 </>
                    //                             )}
                    //                         </ul>
                    //                     </div>
                    //                 </div>
                    //                 {!isSmallScreen && (
                    //                     <div className="col-lg-2 col-md-1">
                    //                         <div className="topbar-social text-center text-md-right">
                    //                             <ul>
                    //                             </ul>
                    //                         </div>
                    //                     </div>
                    //                 )}
                    //             </div>
                    //         </div>
                    //     </div>
                    // </div>

//                     <div
//   className={`header top-header ${isFixed ? 'fixed' : ''}`}
//   style={{
//     background: '#c21717',
//     color: '#ffffff',
//     fontFamily: 'Arial, sans-serif',
//     fontSize: '14px',
//     padding: '2px 20px',
//     height: isSmallScreen ? "auto" : "32px"
//   }}
// >
//   <div className="topbar bg-theme-colored2">
//     <div className="container-fluid p-0">
//       <div className="row">
//         <div className={isSmallScreen ? "col-12" : "col-lg-12 col-md-12 xs-mb-12 p-0"}>
//           <div className={`topbar-call ${isSmallScreen ? 'text-center' : 'text-center text-md-left'}`}>
//             <ul 
//               className={`topbar-links ${isSmallScreen ? 'mobile-layout' : 'desktop-layout'}`} 
//               style={{ 
//                 textDecoration: "none", 
//                 listStyleType: "none", 
//                 padding: 0, 
//                 margin: 0 
//               }}
//               role="menubar"
//               aria-label="Quick links"
//             >
//               {isSmallScreen ? (
//                 // Mobile Layout - Responsive grid
//                 <>
//                   <li className="topbar-link-item mobile-item" role="none">
//                     <a
//                       href="https://eadmin.iitd.ac.in/"
//                       className='text-decoration-none text-white d-flex align-items-center justify-content-center'
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       role="menuitem"
//                       aria-label="ERP System"
//                     >
//                       <FaBriefcase className='me-1' style={{ fontSize: "14px" }} aria-hidden="true" />
//                       <span>ERP</span>
//                     </a>
//                   </li>
//                   <li className="topbar-link-item mobile-item" role="none">
//                     <a 
//                       className='text-decoration-none d-flex align-items-center justify-content-center' 
//                       href="https://home.iitd.ac.in/" 
//                       target="_blank"
//                       role="menuitem"
//                       aria-label="IIT Delhi Website"
//                     >
//                       <span>IITD</span>
//                       <FaExternalLinkSquareAlt className='ms-1' style={{ fontSize: "14px" }} aria-hidden="true" />
//                     </a>
//                   </li>
//                   <li className="topbar-link-item mobile-item" role="none">
//                     <button
//                       className="text-decoration-none d-flex align-items-center justify-content-center border-0 bg-transparent text-white w-100"
//                       style={{ cursor: 'pointer' }}
//                       onClick={(e) => {
//                         const target = e.currentTarget;
//                         target.innerHTML = `
//                           <div class="d-flex align-items-center justify-content-center">
//                             <svg style="font-size: 14px; margin-right: 4px;" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 512 512" aria-hidden="true">
//                               <path d="M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"/>
//                             </svg>
//                             <span>sysadm@cc.iitd.ac.in</span>
//                           </div>
//                         `;
//                         target.style.cursor = 'auto';
//                         target.setAttribute('aria-label', 'Email: sysadm@cc.iitd.ac.in');
//                       }}
//                       aria-label="Show email address"
//                     >
//                       <FaEnvelope style={{ fontSize: "14px" }} aria-hidden="true" />
//                       <span className="ms-1">Email</span>
//                     </button>
//                   </li>
//                   <li className="topbar-link-item mobile-item" role="none">
//                     <a 
//                       className='text-decoration-none d-flex align-items-center justify-content-center' 
//                       href="tel:011-2659-7220"
//                       role="menuitem"
//                       aria-label="Call 011-2659-7220"
//                     >
//                       <FaPhoneSquareAlt className='me-1' style={{ fontSize: "14px" }} aria-hidden="true" />
//                       <span>Phone</span>
//                     </a>
//                   </li>
//                   <li className="topbar-link-item mobile-item" role="none">
//                     <Link 
//                       to="/services-network" 
//                       className='text-decoration-none text-white d-flex align-items-center justify-content-center'
//                       role="menuitem"
//                       aria-label="Network Services"
//                     >
//                       <FaWifi className='me-1' style={{ fontSize: "14px" }} aria-hidden="true" />
//                       <span>Network</span>
//                     </Link>
//                   </li>
//                   <li className="topbar-link-item mobile-item" role="none">
//                     <Link 
//                       to="/services-web-services" 
//                       className='text-decoration-none text-white d-flex align-items-center justify-content-center'
//                       role="menuitem"
//                       aria-label="Web Services"
//                     >
//                       <FaGlobe className='me-1' style={{ fontSize: "14px" }} aria-hidden="true" />
//                       <span>Web</span>
//                     </Link>
//                   </li>
//                   <li className="topbar-link-item mobile-item" role="none">
//                     <Link 
//                       to="/services-software" 
//                       className='text-decoration-none text-white d-flex align-items-center justify-content-center'
//                       role="menuitem"
//                       aria-label="Software Services"
//                     >
//                       <FaCogs className='me-1' style={{ fontSize: "14px" }} aria-hidden="true" />
//                       <span>Software</span>
//                     </Link>
//                   </li>
//                   <li className="topbar-link-item mobile-item" role="none">
//                     <a
//                       href="https://baadal.iitd.ac.in/baadal"
//                       className='text-decoration-none text-white d-flex align-items-center justify-content-center'
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       role="menuitem"
//                       aria-label="Baadal Cloud Services"
//                     >
//                       <FaCloud className='me-1' style={{ fontSize: "14px" }} aria-hidden="true" />
//                       <span>Baadal</span>
//                     </a>
//                   </li>
//                   <li className="topbar-link-item mobile-item" role="none">
//                     <a
//                       href="https://supercomputing.iitd.ac.in/"
//                       className='text-decoration-none text-white d-flex align-items-center justify-content-center'
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       role="menuitem"
//                       aria-label="High Performance Computing"
//                     >
//                       <FaServer className='me-1' style={{ fontSize: "14px" }} aria-hidden="true" />
//                       <span>HPC</span>
//                     </a>
//                   </li>
//                 </>
//               ) : (
//                 // Desktop Layout
//                 <>
//                   <li className="topbar-link-item desktop-item" role="none">
//                     <a
//                       href="https://eadmin.iitd.ac.in/"
//                       className='text-decoration-none text-white d-flex align-items-center'
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       role="menuitem"
//                       aria-label="ERP System"
//                     >
//                       <FaBriefcase className='me-2' style={{ fontSize: "17px" }} aria-hidden="true" />
//                       <span>ERP</span>
//                     </a>
//                   </li>
//                   <li className="topbar-link-item desktop-item" role="none">
//                     <FaLightbulb className='me-2' style={{ fontSize: "17px" }} aria-hidden="true" />
//                     <Link to="/howto" className='text-decoration-none text-white' role="menuitem" aria-label="How To Guides">
//                       <span>How To</span>
//                     </Link>
//                   </li>
//                   <li className="topbar-link-item desktop-item" role="none">
//                     <FaWifi className='me-2' style={{ fontSize: "17px" }} aria-hidden="true" />
//                     <Link to="/services-network" className='text-decoration-none text-white' role="menuitem" aria-label="Networking Services">
//                       <span>Networking</span>
//                     </Link>
//                   </li>
//                   <li className="topbar-link-item desktop-item" role="none">
//                     <FaGlobe className='me-2' style={{ fontSize: "17px" }} aria-hidden="true" />
//                     <Link to="/services-web-services" className='text-decoration-none text-white' role="menuitem" aria-label="Web Services">
//                       <span>Web Services</span>
//                     </Link>
//                   </li>
//                   <li className="topbar-link-item desktop-item" role="none">
//                     <FaCogs className='me-2' style={{ fontSize: "17px" }} aria-hidden="true" />
//                     <Link to="/services-software" className='text-decoration-none text-white' role="menuitem" aria-label="Software Services">
//                       <span>Software</span>
//                     </Link>
//                   </li>
//                   <li className="topbar-link-item desktop-item" role="none">
//                     <FaCloud className='me-2' style={{ fontSize: "17px" }} aria-hidden="true" />
//                     <a
//                       href="https://baadal.iitd.ac.in/baadal"
//                       className='text-decoration-none text-white'
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       role="menuitem"
//                       aria-label="Baadal Cloud Services"
//                     >
//                       <span>Baadal</span>
//                     </a>
//                   </li>
//                   <li className="topbar-link-item desktop-item" role="none">
//                     <FaServer className='me-2' style={{ fontSize: "17px" }} aria-hidden="true" />
//                     <a
//                       href="https://supercomputing.iitd.ac.in/"
//                       className='text-decoration-none text-white'
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       role="menuitem"
//                       aria-label="High Performance Computing"
//                     >
//                       <span>HPC</span>
//                     </a>
//                   </li>
//                   <li className="topbar-link-item desktop-item" role="none">
//                     <a 
//                       className='text-decoration-none d-flex align-items-center' 
//                       href="https://home.iitd.ac.in/" 
//                       target="_blank"
//                       role="menuitem"
//                       aria-label="IIT Delhi Website"
//                     >
//                       <span>IITD Website</span>
//                       <FaExternalLinkSquareAlt className='ms-2' style={{ fontSize: "17px" }} aria-hidden="true" />
//                     </a>
//                   </li>
//                   <li className="topbar-link-item desktop-item" role="none">
//                     <button
//                       className="text-decoration-none d-flex align-items-center border-0 bg-transparent text-white"
//                       style={{ cursor: 'pointer' }}
//                       onClick={(e) => {
//                         const target = e.currentTarget;
//                         target.innerHTML = `
//                           <div class="d-flex align-items-center">
//                             <svg style="font-size: 17px; margin-right: 8px;" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 512 512" aria-hidden="true">
//                               <path d="M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"/>
//                             </svg>
//                             <span>sysadm@cc.iitd.ac.in</span>
//                           </div>
//                         `;
//                         target.style.cursor = 'auto';
//                         target.setAttribute('aria-label', 'Email: sysadm@cc.iitd.ac.in');
//                       }}
//                       aria-label="Show email address"
//                     >
//                       <FaEnvelope style={{ fontSize: "17px" }} aria-hidden="true" />
//                     </button>
//                   </li>
//                   <li className="topbar-link-item desktop-item" role="none">
//                     <FaPhoneSquareAlt className='me-2' style={{ fontSize: "17px", textDecoration: "none" }} aria-hidden="true" />
//                     <a 
//                       className='text-decoration-none' 
//                       style={{ textDecoration: "none" }} 
//                       href="tel:011-2659-7220"
//                       role="menuitem"
//                       aria-label="Call 011-2659-7220"
//                     >
//                       <span>011-2659-7220</span>
//                     </a>
//                   </li>
//                 </>
//               )}
//             </ul>
//           </div>
//         </div>
//         {!isSmallScreen && (
//           <div className="col-lg-2 col-md-1">
//             <div className="topbar-social text-center text-md-right">
//               <ul role="menu" aria-label="Social media links">
//                 {/* Social media links can be added here */}
//               </ul>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   </div>
// </div>

// <div
//   className={`header top-header ${isFixed ? 'fixed' : ''}`}
//   style={{
//     background: '#c21717',
//     color: '#ffffff',
//     fontFamily: 'Arial, sans-serif',
//     fontSize: '14px',
//     padding: '2px 20px',
//     height: isSmallScreen ? "auto" : "32px"
//   }}
// >
//   <div className="topbar bg-theme-colored2">
//     <div className="container-fluid p-0">
//       <div className="row">
//         <div className={isSmallScreen ? "col-12" : "col-lg-12 col-md-12 xs-mb-12 p-0"}>
//           <div className={`topbar-call ${isSmallScreen ? 'text-center' : 'text-center text-md-left'}`}>
//             <ul 
//               className={`topbar-links ${isSmallScreen ? 'mobile-layout' : 'desktop-layout'}`} 
//               style={{ 
//                 textDecoration: "none", 
//                 listStyleType: "none", 
//                 padding: 0, 
//                 margin: 0 
//               }}
//               role="menubar"
//               aria-label="Quick links"
//             >
//               {isSmallScreen ? (
//                 // Mobile Layout - Responsive grid
//                 <>
//                   <li className="topbar-link-item mobile-item" role="none">
//                     <a
//                       href="https://eadmin.iitd.ac.in/"
//                       className='text-decoration-none text-white d-flex align-items-center justify-content-center'
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       role="menuitem"
//                       aria-label="ERP System"
//                     >
//                       <FaBriefcase className='me-1' style={{ fontSize: "14px" }} aria-hidden="true" />
//                       <span>ERP</span>
//                     </a>
//                   </li>
//                   <li className="topbar-link-item mobile-item" role="none">
//                     <a 
//                       className='text-decoration-none d-flex align-items-center justify-content-center' 
//                       href="https://home.iitd.ac.in/" 
//                       target="_blank"
//                       role="menuitem"
//                       aria-label="IIT Delhi Website"
//                     >
//                       <span>IITD</span>
//                       <FaExternalLinkSquareAlt className='ms-1' style={{ fontSize: "14px" }} aria-hidden="true" />
//                     </a>
//                   </li>
//                   <li className="topbar-link-item mobile-item" role="none">
//                     <button
//                       className="text-decoration-none d-flex align-items-center justify-content-center border-0 bg-transparent text-white w-100"
//                       style={{ cursor: 'pointer' }}
//                       onClick={(e) => {
//                         const target = e.currentTarget;
//                         target.innerHTML = `
//                           <div class="d-flex align-items-center justify-content-center">
//                             <svg style="font-size: 14px; margin-right: 4px;" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 512 512" aria-hidden="true">
//                               <path d="M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"/>
//                             </svg>
//                             <span>sysadm@cc.iitd.ac.in</span>
//                           </div>
//                         `;
//                         target.style.cursor = 'auto';
//                         target.setAttribute('aria-label', 'Email: sysadm@cc.iitd.ac.in');
//                       }}
//                       aria-label="Show email address"
//                     >
//                       <FaEnvelope style={{ fontSize: "14px" }} aria-hidden="true" />
//                       <span className="ms-1">Email</span>
//                     </button>
//                   </li>
//                   <li className="topbar-link-item mobile-item" role="none">
//                     <a 
//                       className='text-decoration-none d-flex align-items-center justify-content-center' 
//                       href="tel:011-2659-7220"
//                       role="menuitem"
//                       aria-label="Call 011-2659-7220"
//                     >
//                       <FaPhoneSquareAlt className='me-1' style={{ fontSize: "14px" }} aria-hidden="true" />
//                       <span>Phone</span>
//                     </a>
//                   </li>
//                   <li className="topbar-link-item mobile-item" role="none">
//                     <Link 
//                       to="/services-network" 
//                       className='text-decoration-none text-white d-flex align-items-center justify-content-center'
//                       role="menuitem"
//                       aria-label="Network Services"
//                     >
//                       <FaWifi className='me-1' style={{ fontSize: "14px" }} aria-hidden="true" />
//                       <span>Network</span>
//                     </Link>
//                   </li>
//                   <li className="topbar-link-item mobile-item" role="none">
//                     <Link 
//                       to="/services-web-services" 
//                       className='text-decoration-none text-white d-flex align-items-center justify-content-center'
//                       role="menuitem"
//                       aria-label="Web Services"
//                     >
//                       <FaGlobe className='me-1' style={{ fontSize: "14px" }} aria-hidden="true" />
//                       <span>Web</span>
//                     </Link>
//                   </li>
//                   <li className="topbar-link-item mobile-item" role="none">
//                     <Link 
//                       to="/services-software" 
//                       className='text-decoration-none text-white d-flex align-items-center justify-content-center'
//                       role="menuitem"
//                       aria-label="Software Services"
//                     >
//                       <FaCogs className='me-1' style={{ fontSize: "14px" }} aria-hidden="true" />
//                       <span>Software</span>
//                     </Link>
//                   </li>
//                   <li className="topbar-link-item mobile-item" role="none">
//                     <a
//                       href="https://baadal.iitd.ac.in/baadal"
//                       className='text-decoration-none text-white d-flex align-items-center justify-content-center'
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       role="menuitem"
//                       aria-label="Baadal Cloud Services"
//                     >
//                       <FaCloud className='me-1' style={{ fontSize: "14px" }} aria-hidden="true" />
//                       <span>Baadal</span>
//                     </a>
//                   </li>
//                   <li className="topbar-link-item mobile-item" role="none">
//                     <a
//                       href="https://supercomputing.iitd.ac.in/"
//                       className='text-decoration-none text-white d-flex align-items-center justify-content-center'
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       role="menuitem"
//                       aria-label="High Performance Computing"
//                     >
//                       <FaServer className='me-1' style={{ fontSize: "14px" }} aria-hidden="true" />
//                       <span>HPC</span>
//                     </a>
//                   </li>
//                 </>
//               ) : (
//                 // Desktop Layout
//                 <>
//                   <li className="topbar-link-item desktop-item" role="none">
//                     <a
//                       href="https://eadmin.iitd.ac.in/"
//                       className='text-decoration-none text-white d-flex align-items-center'
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       role="menuitem"
//                       aria-label="ERP System"
//                     >
//                       <FaBriefcase className='me-2' style={{ fontSize: "17px" }} aria-hidden="true" />
//                       <span>ERP</span>
//                     </a>
//                   </li>
//                   <li className="topbar-link-item desktop-item" role="none">
//                     <FaLightbulb className='me-2' style={{ fontSize: "17px" }} aria-hidden="true" />
//                     <Link to="/howto" className='text-decoration-none text-white' role="menuitem" aria-label="How To Guides">
//                       <span>How To</span>
//                     </Link>
//                   </li>
//                   <li className="topbar-link-item desktop-item" role="none">
//                     <FaWifi className='me-2' style={{ fontSize: "17px" }} aria-hidden="true" />
//                     <Link to="/services-network" className='text-decoration-none text-white' role="menuitem" aria-label="Networking Services">
//                       <span>Networking</span>
//                     </Link>
//                   </li>
//                   <li className="topbar-link-item desktop-item" role="none">
//                     <FaGlobe className='me-2' style={{ fontSize: "17px" }} aria-hidden="true" />
//                     <Link to="/services-web-services" className='text-decoration-none text-white' role="menuitem" aria-label="Web Services">
//                       <span>Web Services</span>
//                     </Link>
//                   </li>
//                   <li className="topbar-link-item desktop-item" role="none">
//                     <FaCogs className='me-2' style={{ fontSize: "17px" }} aria-hidden="true" />
//                     <Link to="/services-software" className='text-decoration-none text-white' role="menuitem" aria-label="Software Services">
//                       <span>Software</span>
//                     </Link>
//                   </li>
//                   <li className="topbar-link-item desktop-item" role="none">
//                     <FaCloud className='me-2' style={{ fontSize: "17px" }} aria-hidden="true" />
//                     <a
//                       href="https://baadal.iitd.ac.in/baadal"
//                       className='text-decoration-none text-white'
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       role="menuitem"
//                       aria-label="Baadal Cloud Services"
//                     >
//                       <span>Baadal</span>
//                     </a>
//                   </li>
//                   <li className="topbar-link-item desktop-item" role="none">
//                     <FaServer className='me-2' style={{ fontSize: "17px" }} aria-hidden="true" />
//                     <a
//                       href="https://supercomputing.iitd.ac.in/"
//                       className='text-decoration-none text-white'
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       role="menuitem"
//                       aria-label="High Performance Computing"
//                     >
//                       <span>HPC</span>
//                     </a>
//                   </li>
//                   <li className="topbar-link-item desktop-item" role="none">
//                     <a 
//                       className='text-decoration-none d-flex align-items-center' 
//                       href="https://home.iitd.ac.in/" 
//                       target="_blank"
//                       role="menuitem"
//                       aria-label="IIT Delhi Website"
//                     >
//                       <span>IITD Website</span>
//                       <FaExternalLinkSquareAlt className='ms-2' style={{ fontSize: "17px" }} aria-hidden="true" />
//                     </a>
//                   </li>
//                   <li className="topbar-link-item desktop-item" role="none">
//                     <button
//                       className="text-decoration-none d-flex align-items-center border-0 bg-transparent text-white"
//                       style={{ cursor: 'pointer' }}
//                       onClick={(e) => {
//                         const target = e.currentTarget;
//                         target.innerHTML = `
//                           <div class="d-flex align-items-center">
//                             <svg style="font-size: 17px; margin-right: 8px;" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 512 512" aria-hidden="true">
//                               <path d="M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"/>
//                             </svg>
//                             <span>sysadm@cc.iitd.ac.in</span>
//                           </div>
//                         `;
//                         target.style.cursor = 'auto';
//                         target.setAttribute('aria-label', 'Email: sysadm@cc.iitd.ac.in');
//                       }}
//                       aria-label="Show email address"
//                     >
//                       <FaEnvelope style={{ fontSize: "17px" }} aria-hidden="true" />
//                     </button>
//                   </li>
//                   <li className="topbar-link-item desktop-item" role="none">
//                     <FaPhoneSquareAlt className='me-2' style={{ fontSize: "17px", textDecoration: "none" }} aria-hidden="true" />
//                     <a 
//                       className='text-decoration-none' 
//                       style={{ textDecoration: "none" }} 
//                       href="tel:011-2659-7220"
//                       role="menuitem"
//                       aria-label="Call 011-2659-7220"
//                     >
//                       <span>011-2659-7220</span>
//                     </a>
//                   </li>
//                 </>
//               )}
//             </ul>
//           </div>
//         </div>
//         {!isSmallScreen && (
//           <div className="col-lg-2 col-md-1">
//             <div className="topbar-social text-center text-md-right">
//               <ul role="menu" aria-label="Social media links">
//                 {/* Social media links can be added here */}
//               </ul>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   </div>
// </div>

<div
  className={`header top-header ${isFixed ? 'fixed' : ''}`}
  style={{
    background: '#c21717',
    color: '#ffffff',
    fontFamily: 'Arial, sans-serif',
    fontSize: '14px',
    padding: '0px 0px',
    height: isSmallScreen ? "auto" : "32px"
  }}
>
  <div className="topbar bg-theme-colored2">
    <div className="container-fluid p-0">
      <div className="row">
        <div className={isSmallScreen ? "col-12" : "col-lg-12 col-md-12 xs-mb-12 p-0"}>
          <div className={`topbar-call ${isSmallScreen ? 'text-center' : 'text-center text-md-left'}`}>
            <ul 
              className={`topbar-links ${isSmallScreen ? 'mobile-layout' : 'desktop-layout'}`} 
              style={{ 
                textDecoration: "none", 
                listStyleType: "none", 
                padding: 0, 
                margin: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexWrap: "wrap"
              }}
              role="menubar"
              aria-label="Quick links"
            >
              {isSmallScreen ? (
                // Mobile Layout - Fixed grid
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(3, 1fr)',
                  gap: '0px',
                  width: '100%',
                  padding: '4px'
                }}>
                  <li className="topbar-link-item mobile-item" role="none" style={{ display: 'flex', justifyContent: 'center' }}>
                    <a
                      href="https://eadmin.iitd.ac.in/"
                      className='text-decoration-none text-white d-flex align-items-center justify-content-center'
                      target="_blank"
                      rel="noopener noreferrer"
                      role="menuitem"
                      aria-label="ERP System"
                      style={{ gap: '4px', padding: '4px' }}
                    >
                      <FaBriefcase style={{ fontSize: "14px" }} aria-hidden="true" />
                      <span style={{ fontSize: "11px" }}>ERP</span>
                    </a>
                  </li>
                  <li className="topbar-link-item mobile-item" role="none" style={{ display: 'flex', justifyContent: 'center' }}>
                    <a 
                      className='text-decoration-none d-flex align-items-center justify-content-center' 
                      href="https://home.iitd.ac.in/" 
                      target="_blank"
                      role="menuitem"
                      aria-label="IIT Delhi Website"
                      style={{ gap: '4px', padding: '4px' }}
                    >
                      <span style={{ fontSize: "11px" }}>IITD</span>
                      <FaExternalLinkSquareAlt style={{ fontSize: "14px" }} aria-hidden="true" />
                    </a>
                  </li>
                  <li className="topbar-link-item mobile-item" role="none" style={{ display: 'flex', justifyContent: 'center' }}>
                    <button
                      className="text-decoration-none d-flex align-items-center justify-content-center border-0 bg-transparent text-white w-100"
                      style={{ cursor: 'pointer', gap: '4px', padding: '4px' }}
                      onClick={(e) => {
                        const target = e.currentTarget;
                        target.innerHTML = `
                          <div class="d-flex align-items-center justify-content-center" style="gap: 4px">
                            <svg style="font-size: 14px;" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 512 512" aria-hidden="true">
                              <path d="M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"/>
                            </svg>
                            <span style="font-size: 11px">sysadm@cc.iitd.ac.in</span>
                          </div>
                        `;
                        target.style.cursor = 'auto';
                        target.setAttribute('aria-label', 'Email: sysadm@cc.iitd.ac.in');
                      }}
                      aria-label="Show email address"
                    >
                      <FaEnvelope style={{ fontSize: "14px" }} aria-hidden="true" />
                      <span style={{ fontSize: "11px" }}>Email</span>
                    </button>
                  </li>
                  <li className="topbar-link-item mobile-item" role="none" style={{ display: 'flex', justifyContent: 'center' }}>
                    <a 
                      className='text-decoration-none d-flex align-items-center justify-content-center' 
                      href="tel:011-2659-7220"
                      role="menuitem"
                      aria-label="Call 011-2659-7220"
                      style={{ gap: '4px', padding: '4px' }}
                    >
                      <FaPhoneSquareAlt style={{ fontSize: "14px" }} aria-hidden="true" />
                      <span style={{ fontSize: "11px" }}>Phone</span>
                    </a>
                  </li>
                  <li className="topbar-link-item mobile-item" role="none" style={{ display: 'flex', justifyContent: 'center' }}>
                    <Link 
                      to="/services-network" 
                      className='text-decoration-none text-white d-flex align-items-center justify-content-center'
                      role="menuitem"
                      aria-label="Network Services"
                      style={{ gap: '4px', padding: '4px' }}
                    >
                      <FaWifi style={{ fontSize: "14px" }} aria-hidden="true" />
                      <span style={{ fontSize: "11px" }}>Network</span>
                    </Link>
                  </li>
                  <li className="topbar-link-item mobile-item" role="none" style={{ display: 'flex', justifyContent: 'center' }}>
                    <Link 
                      to="/services-web-services" 
                      className='text-decoration-none text-white d-flex align-items-center justify-content-center'
                      role="menuitem"
                      aria-label="Web Services"
                      style={{ gap: '4px', padding: '4px' }}
                    >
                      <FaGlobe style={{ fontSize: "14px" }} aria-hidden="true" />
                      <span style={{ fontSize: "11px" }}>Web</span>
                    </Link>
                  </li>
                  <li className="topbar-link-item mobile-item" role="none" style={{ display: 'flex', justifyContent: 'center' }}>
                    <Link 
                      to="/services-software" 
                      className='text-decoration-none text-white d-flex align-items-center justify-content-center'
                      role="menuitem"
                      aria-label="Software Services"
                      style={{ gap: '4px', padding: '4px' }}
                    >
                      <FaCogs style={{ fontSize: "14px" }} aria-hidden="true" />
                      <span style={{ fontSize: "11px" }}>Software</span>
                    </Link>
                  </li>
                  <li className="topbar-link-item mobile-item" role="none" style={{ display: 'flex', justifyContent: 'center' }}>
                    <a
                      href="https://baadal.iitd.ac.in/baadal"
                      className='text-decoration-none text-white d-flex align-items-center justify-content-center'
                      target="_blank"
                      rel="noopener noreferrer"
                      role="menuitem"
                      aria-label="Baadal Cloud Services"
                      style={{ gap: '4px', padding: '4px' }}
                    >
                      <FaCloud style={{ fontSize: "14px" }} aria-hidden="true" />
                      <span style={{ fontSize: "11px" }}>Baadal</span>
                    </a>
                  </li>
                  <li className="topbar-link-item mobile-item" role="none" style={{ display: 'flex', justifyContent: 'center' }}>
                    <a
                      href="https://supercomputing.iitd.ac.in/"
                      className='text-decoration-none text-white d-flex align-items-center justify-content-center'
                      target="_blank"
                      rel="noopener noreferrer"
                      role="menuitem"
                      aria-label="High Performance Computing"
                      style={{ gap: '4px', padding: '4px' }}
                    >
                      <FaServer style={{ fontSize: "14px" }} aria-hidden="true" />
                      <span style={{ fontSize: "11px" }}>HPC</span>
                    </a>
                  </li>
                </div>
              ) : (
                // Desktop Layout - FIXED VERSION
                <>
                  <li className="topbar-link-item desktop-item" role="none" style={{ display: "flex", alignItems: "center", margin: "0 8px" }}>
                    <a
                      href="https://eadmin.iitd.ac.in/"
                      className='text-decoration-none text-white d-flex align-items-center'
                      target="_blank"
                      rel="noopener noreferrer"
                      role="menuitem"
                      aria-label="ERP System"
                      style={{ gap: "6px", padding: "4px 8px" }}
                    >
                      <FaBriefcase style={{ fontSize: "15px", flexShrink: 0 }} aria-hidden="true" />
                      <span style={{ whiteSpace: "nowrap", fontSize: "13px" }}>ERP</span>
                    </a>
                  </li>
                  
                  <li className="topbar-link-item desktop-item" role="none" style={{ display: "flex", alignItems: "center", margin: "0 8px" }}>
                    <Link 
                      to="/howto" 
                      className='text-decoration-none text-white d-flex align-items-center'
                      role="menuitem" 
                      aria-label="How To Guides"
                      style={{ gap: "6px", padding: "4px 8px" }}
                    >
                      <FaLightbulb style={{ fontSize: "15px", flexShrink: 0 }} aria-hidden="true" />
                      <span style={{ whiteSpace: "nowrap", fontSize: "13px" }}>How To</span>
                    </Link>
                  </li>
                  
                  <li className="topbar-link-item desktop-item" role="none" style={{ display: "flex", alignItems: "center", margin: "0 8px" }}>
                    <Link 
                      to="/services-network" 
                      className='text-decoration-none text-white d-flex align-items-center'
                      role="menuitem" 
                      aria-label="Networking Services"
                      style={{ gap: "6px", padding: "4px 8px" }}
                    >
                      <FaWifi style={{ fontSize: "15px", flexShrink: 0 }} aria-hidden="true" />
                      <span style={{ whiteSpace: "nowrap", fontSize: "13px" }}>Networking</span>
                    </Link>
                  </li>
                  
                  <li className="topbar-link-item desktop-item" role="none" style={{ display: "flex", alignItems: "center", margin: "0 8px" }}>
                    <Link 
                      to="/services-web-services" 
                      className='text-decoration-none text-white d-flex align-items-center'
                      role="menuitem" 
                      aria-label="Web Services"
                      style={{ gap: "6px", padding: "4px 8px" }}
                    >
                      <FaGlobe style={{ fontSize: "15px", flexShrink: 0 }} aria-hidden="true" />
                      <span style={{ whiteSpace: "nowrap", fontSize: "13px" }}>Web Services</span>
                    </Link>
                  </li>
                  
                  <li className="topbar-link-item desktop-item" role="none" style={{ display: "flex", alignItems: "center", margin: "0 8px" }}>
                    <Link 
                      to="/services-software" 
                      className='text-decoration-none text-white d-flex align-items-center'
                      role="menuitem" 
                      aria-label="Software Services"
                      style={{ gap: "6px", padding: "4px 8px" }}
                    >
                      <FaCogs style={{ fontSize: "15px", flexShrink: 0 }} aria-hidden="true" />
                      <span style={{ whiteSpace: "nowrap", fontSize: "13px" }}>Software</span>
                    </Link>
                  </li>
                  
                  <li className="topbar-link-item desktop-item" role="none" style={{ display: "flex", alignItems: "center", margin: "0 8px" }}>
                    <a
                      href="https://baadal.iitd.ac.in/baadal"
                      className='text-decoration-none text-white d-flex align-items-center'
                      target="_blank"
                      rel="noopener noreferrer"
                      role="menuitem"
                      aria-label="Baadal Cloud Services"
                      style={{ gap: "6px", padding: "4px 8px" }}
                    >
                      <FaCloud style={{ fontSize: "15px", flexShrink: 0 }} aria-hidden="true" />
                      <span style={{ whiteSpace: "nowrap", fontSize: "13px" }}>Baadal</span>
                    </a>
                  </li>
                  
                  <li className="topbar-link-item desktop-item" role="none" style={{ display: "flex", alignItems: "center", margin: "0 8px" }}>
                    <a
                      href="https://supercomputing.iitd.ac.in/"
                      className='text-decoration-none text-white d-flex align-items-center'
                      target="_blank"
                      rel="noopener noreferrer"
                      role="menuitem"
                      aria-label="High Performance Computing"
                      style={{ gap: "6px", padding: "4px 8px" }}
                    >
                      <FaServer style={{ fontSize: "15px", flexShrink: 0 }} aria-hidden="true" />
                      <span style={{ whiteSpace: "nowrap", fontSize: "13px" }}>HPC</span>
                    </a>
                  </li>
                  
                  <li className="topbar-link-item desktop-item" role="none" style={{ display: "flex", alignItems: "center", margin: "0 8px" }}>
                    <a 
                      className='text-decoration-none text-white d-flex align-items-center' 
                      href="https://home.iitd.ac.in/" 
                      target="_blank"
                      role="menuitem"
                      aria-label="IIT Delhi Website"
                      style={{ gap: "6px", padding: "4px 8px" }}
                    >
                      <span style={{ whiteSpace: "nowrap", fontSize: "13px" }}>IITD Website</span>
                      <FaExternalLinkSquareAlt style={{ fontSize: "14px", flexShrink: 0 }} aria-hidden="true" />
                    </a>
                  </li>
                  
                  <li className="topbar-link-item desktop-item" role="none" style={{ display: "flex", alignItems: "center", margin: "0 8px" }}>
                    <button
                      className="text-decoration-none d-flex align-items-center border-0 bg-transparent text-white"
                      style={{ cursor: 'pointer', gap: "6px", padding: "4px 8px" }}
                      onClick={(e) => {
                        const target = e.currentTarget;
                        target.innerHTML = `
                          <div class="d-flex align-items-center" style="gap: 6px">
                            <svg style="font-size: 15px; flex-shrink: 0" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 512 512" aria-hidden="true">
                              <path d="M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"/>
                            </svg>
                            <span style="white-space: nowrap; font-size: 13px">sysadm@cc.iitd.ac.in</span>
                          </div>
                        `;
                        target.style.cursor = 'auto';
                        target.setAttribute('aria-label', 'Email: sysadm@cc.iitd.ac.in');
                      }}
                      aria-label="Show email address"
                    >
                      <FaEnvelope style={{ fontSize: "15px", flexShrink: 0 }} aria-hidden="true" />
                      <span style={{ whiteSpace: "nowrap", fontSize: "13px" }}>Email</span>
                    </button>
                  </li>
                  
                  <li className="topbar-link-item desktop-item" role="none" style={{ display: "flex", alignItems: "center", margin: "0 8px" }}>
                    <a 
                      className='text-decoration-none text-white d-flex align-items-center' 
                      href="tel:011-2659-7220"
                      role="menuitem"
                      aria-label="Call 011-2659-7220"
                      style={{ gap: "6px", padding: "4px 8px" }}
                    >
                      <FaPhoneSquareAlt style={{ fontSize: "15px", flexShrink: 0 }} aria-hidden="true" />
                      <span style={{ whiteSpace: "nowrap", fontSize: "13px" }}>011-2659-7220</span>
                    </a>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>
        {!isSmallScreen && (
          <div className="col-lg-2 col-md-1">
            <div className="topbar-social text-center text-md-right">
              <ul role="menu" aria-label="Social media links">
                {/* Social media links can be added here */}
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  </div>
</div>
                ) : ""
            }
            <nav className={`navbar navbar-expand-lg header p-0 bottom-header mainHeader ${isFixed ? 'fixed' : ''}`}
                style={{
                    backgroundColor: 'light',
                    justifyContent: 'space-around',
                }}
            >
                <div className="container-fluid justify-content-lg-around">
                    <Link className="navbar-brand" to="/">
                        <img
                            src={Logo}
                            alt="Logo"
                            height="76px"
                            className="d-inline-block align-top"
                        />
                    </Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav ms-auto">
                   
                            <li className="nav-item">
                                <NavLink
                                    className={({ isActive }) => 
                                        `nav-link homeicons ${isActive ? 'activehomeactivated' : 'activehome'}`
                                    }
                                    onClick={() => handleDropdownToggle('Home')}
                                    to="/"
                                    end
                                >
                                    <FaHome style={{ marginBottom: "2px", fontSize: "larger" }} color='#c21717' />
                                </NavLink>
                            </li>

                            <li className="nav-item dropdown">
                                <NavLink
                                    to="/services"
                                    className={`nav-link dropdown-toggle ${activeDropdown === 'services' ? 'active' : ''}`}
                                    onClick={() => handleDropdownToggle('services')}
                                    role="button"
                                    aria-expanded={activeDropdown === 'services' ? 'true' : 'false'}
                                >
                                    Services  <IoIosArrowDown />
                                </NavLink>
                                <ul className="dropdown-menu">
                                    <li><NavLink className={`dropdown-item ${activeItem === 'software' ? 'active' : ''}`} to="/services-software" onClick={() => handleItemClick('software')}>Software</NavLink></li>
                                    <li><NavLink className={`dropdown-item ${activeItem === 'network' ? 'active' : ''}`} to="/services-network" onClick={() => handleItemClick('network')}>Network</NavLink></li>
                                    <li><NavLink className={`dropdown-item ${activeItem === 'webservices' ? 'active' : ''}`} to="/services-web-services" onClick={() => handleItemClick('webservices')}>Web Services</NavLink></li>
                                    <li><NavLink className={`dropdown-item ${activeItem === 'useradmin' ? 'active' : ''}`} to="/services-user-admin-infra" onClick={() => handleItemClick('useradmin')}>User Admin & Infra</NavLink></li>
                                    <li><NavLink className={`dropdown-item ${activeItem === 'hpc' ? 'active' : ''}`} to="https://supercomputing.iitd.ac.in/" onClick={() => handleItemClick('hpc')}>HPC</NavLink></li>
                                    <li><NavLink className={`dropdown-item ${activeItem === 'cloudcomp' ? 'active' : ''}`} to="https://baadal.iitd.ac.in/baadal" onClick={() => handleItemClick('cloudcomp')}>Cloud Computing</NavLink></li>
                                    <li><NavLink className={`dropdown-item ${activeItem === 'erp' ? 'active' : ''}`} to="/services-erp" onClick={() => handleItemClick('erp')}>ERP</NavLink></li>
                                </ul>
                            </li>

                            <li className="nav-item dropdown">
                                <NavLink
                                    to="/people"
                                    className={`nav-link dropdown-toggle ${activeDropdown === 'People' ? 'active' : ''}`}
                                    role="button"
                                    aria-expanded={activeDropdown === 'People' ? 'true' : 'false'}
                                    onClick={() => handleDropdownToggle('People')}
                                >
                                    People <IoIosArrowDown />
                                </NavLink>
                                <ul className="dropdown-menu">
                                    {userfromwebmaster.userExists || statecsc.userState === 0 ? (
                                        <li>
                                            <NavLink
                                                className={`dropdown-item ${activeItem === 'peoplemanage' ? 'active' : ''}`}
                                                to="/people-manage"
                                                onClick={() => handleItemClick('peoplemanage')}
                                            >
                                                People Manage <MdManageAccounts />
                                            </NavLink>
                                        </li>
                                    ) : null}
                                    <li><NavLink className={`dropdown-item ${activeItem === 'Faculty' ? 'active' : ''}`} to="/academic" onClick={() => handleItemClick('Faculty')}>Academic</NavLink></li>
                                       <li className="dropdown-submenu">
                                        <span className="dropdown-item dropdown-toggle">
                                           Non-academic<IoIosArrowForward className="dropdown-arrow" />
                                        </span>
                                        <ul className="dropdown-menu nested-dropdown">
                                            <li>
                                                <NavLink 
                                                    className={`dropdown-item ${activeItem === 'Ex-Faculty Members' ? 'active' : ''}`} 
                                                    to="/techinal-staff" 
                                                    onClick={() => handleItemClick('Ex-Faculty Members')}
                                                >
                                                  Technical Staff
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink 
                                                    className={`dropdown-item ${activeItem === 'Ex-Staff Members' ? 'active' : ''}`} 
                                                    to="/non-techinal-staff" 
                                                    onClick={() => handleItemClick('Ex-Staff Members')}
                                                >
                                                    Non-Technical Staff
                                                </NavLink>
                                            </li>
                                        </ul>
                                    </li>
                                    <li><NavLink className={`dropdown-item ${activeItem === 'non-academic' ? 'active' : ''}`} to="/former-heads" onClick={() => handleItemClick('non-academic')}>Former Heads</NavLink></li>
                             
                            
                                    <li className="dropdown-submenu">
                                        <span className="dropdown-item dropdown-toggle ms-2">
                                            Former Employees <IoIosArrowForward className="dropdown-arrow" />
                                        </span>
                                        <ul className="dropdown-menu nested-dropdown">
                                            <li>
                                                <NavLink 
                                                    className={`dropdown-item ${activeItem === 'Ex-Faculty Members' ? 'active' : ''}`} 
                                                    to="/ex-academic" 
                                                    onClick={() => handleItemClick('Ex-Faculty Members')}
                                                >
                                                    Academic
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink 
                                                    className={`dropdown-item ${activeItem === 'Ex-Staff Members' ? 'active' : ''}`} 
                                                    to="/ex-non-academic" 
                                                    onClick={() => handleItemClick('Ex-Staff Members')}
                                                >
                                                    Non-academic
                                                </NavLink>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>

                           
                            <li className="nav-item dropdown">
                                <a
                                    className="nav-link dropdown-toggle"
                                    href="#"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Quick Access <IoIosArrowDown />
                                </a>
                                <ul className="dropdown-menu">
                                    <li>
                                        <NavLink
                                            className="dropdown-item"
                                            to="/howto"
                                        >
                                            "How To?" Zone
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink
                                            className="dropdown-item"
                                            to="/getting-started"
                                        >
                                            Getting Started
                                        </NavLink>
                                    </li>
                                    <li>
                                        <a
                                            className="dropdown-item"
                                            href="http://healthgraphs.iitd.ac.in/mrtg/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Healthgraphs (MRTG) <FaExternalLinkAlt />
                                        </a>
                                    </li>

                                </ul>
                            </li>

                        
                            <li className="nav-item">
                                <NavLink className={`nav-link-careers nav-link ${activeDropdown === 'Careers' ? 'active' : ''}`} to="/careers" onClick={() => handleDropdownClick('Careers')}>
                                    Careers
                                </NavLink>
                            </li>

                          
                            <li className="nav-item">
                                <NavLink className={`nav-link-contact nav-link ${activeDropdown === 'Contact' ? 'active' : ''}`} to="/contact" onClick={() => handleDropdownClick('Contact')}>
                                    Contact
                                </NavLink>
                            </li>
                         

                     
                            <li className="nav-item">
                                <a
                                    className="nav-link search-link p-0"
                                    href="#"
                                    ref={searchTriggerRef}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        dispatch(openSearch());
                                    }}
                                    style={{ 
                                        transition: 'transform 0.2s ease',
                                        fontSize: '18px',
                                        color: '#333',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: '100%'
                                    }} 
                                >
                                    <FaSearch className="search-icon-trigger" />
                                </a>
                            </li>
                            <SearchModal triggerRef={searchTriggerRef} />

                         
                            <li className="nav-item dropdown d-flex justify-content-center align-items-center logindropdown">
                                <a
                                    className="nav-link dropdown-toggle p-0 logindropdowna"
                                    href="#"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    {webmaster && webmaster?.userData?.name ? (
                                        Array.isArray(webmaster) ? (
                                            webmaster.length > 0 ? (
                                                webmaster.map((elem, index) => (
                                                    <React.Fragment key={index}>
                                                        {elem?.name || 'No Name'}
                                                        <br />
                                                        <span style={{ fontSize: "11px" }}>({elem?.user_id || 'No ID'})</span>
                                                        <IoIosArrowDown />
                                                    </React.Fragment>
                                                ))
                                            ) : (
                                                <span>No Webmaster Data</span>
                                            )
                                        ) : (
                                            <React.Fragment>
                                                <span className="user-dropdown__manage user-dropdown__manage--disabled"
                                                    aria-disabled="true"
                                                    style={{ pointerEvents: 'none', }}>
                                                    Manage <MdManageAccounts />
                                                    <IoIosArrowDown className="user-dropdown__arrow" />
                                                </span>
                                            </React.Fragment>
                                        )
                                    ) : (
                                        (statecsc.userState === 1 || statecsc.userState === 2) &&
                                            (facultstaff?.facultyprofileExists && facultstaff?.facultyprofileData?.name !== "" ||
                                                staffuser?.staffExists && staffuser?.staffData?.name !== "") ? (
                                            <React.Fragment >
                                                <span className='text-dark'>
                                                    {staffuser?.staffData?.name || facultstaff?.facultyprofileData?.name} <MdManageAccounts />
                                                </span>
                                                <IoIosArrowDown className='text-dark' />
                                            </React.Fragment>
                                        ) : null
                                    )}
                                </a>
                                <ul className="dropdown-menu dropdown-menus">
                                    {webmaster && webmaster?.userData?.name && (
                                        <>
                                            <li className="border-bottom ">
                                                <span className="text-dark">
                                                    {webmaster?.userData?.name || 'No Name'}
                                                </span>
                                                <span className="text-dark" style={{ fontSize: "11px" }}>
                                                    ({webmaster?.userData?.userid || 'No ID'})
                                                </span>
                                            </li>
                                            <li className="border-bottom">
                                                <NavLink
                                                    to="/uploads"
                                                    style={{
                                                        color: "blue",
                                                        borderBottom: "0px solid",
                                                        textDecoration: "none"
                                                    }}
                                                >
                                                    <span style={{ color: "#c21717", fontSize: "15px" }}>
                                                        Uploads <LiaFileUploadSolid className="ms-2" />
                                                    </span>
                                                </NavLink>
                                            </li>
                                            <li className="border-bottom">
                                                <NavLink
                                                    to="/manage-users"
                                                    style={{
                                                        color: "blue",
                                                        borderBottom: "0px solid",
                                                        textDecoration: "none"
                                                    }}
                                                >
                                                    <span style={{ color: "#c21717", fontSize: "15px" }}>
                                                        Manage Users <FaUserEdit className="ms-2" />
                                                    </span>
                                                </NavLink>
                                            </li>
                                            <li className="border-bottom">
                                                <NavLink
                                                    to="/manage-search"
                                                    style={{
                                                        color: "blue",
                                                        borderBottom: "0px solid",
                                                        textDecoration: "none"
                                                    }}
                                                >
                                                    <span style={{ color: "#c21717", fontSize: "15px" }}>
                                                        Manage Search <FaSearch className="ms-2" />
                                                    </span>
                                                </NavLink>
                                            </li>
                                            <li className="border-bottom">
                                                <NavLink
                                                    to="/admin-contact-manager"
                                                    style={{
                                                        color: "blue",
                                                        borderBottom: "0px solid",
                                                        textDecoration: "none"
                                                    }}
                                                >
                                                    <span style={{ color: "#c21717", fontSize: "15px" }}>
                                                        Contact Management <FaUserEdit className="ms-2" />
                                                    </span>
                                                </NavLink>
                                            </li>
                                            <li className="border-bottom">
                                                <NavLink
                                                    to="/manage-journey"
                                                    style={{
                                                        color: "blue",
                                                        borderBottom: "0px solid",
                                                        textDecoration: "none"
                                                    }}
                                                >
                                                    <span style={{ color: "#c21717", fontSize: "15px" }}>
                                                        Manage Journey <FaUserEdit className="ms-2" />
                                                    </span>
                                                </NavLink>
                                            </li>
                                            <li className="border-bottom">
                                                <NavLink
                                                    to="/add-routes"
                                                    style={{
                                                        color: "blue",
                                                        borderBottom: "0px solid",
                                                        textDecoration: "none"
                                                    }}
                                                >
                                                    <span style={{ color: "#c21717", fontSize: "15px" }}>
                                                        Add Routes <TbRouteSquare2 className="ms-2" />
                                                    </span>
                                                </NavLink>
                                            </li>
                                        </>
                                    )}
                                    <li className="border-bottom">
                                        <span
                                            onClick={() => logoutUser()}
                                            style={{ color: "#c21717", cursor: "pointer" }}
                                        >
                                            Logout <FiLogOut className="ms-5" />
                                        </span>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default Header;